import { EVENT_TOPIC_FORCE_LOGOUT } from '@src/Constants';
import apiConfig from '@src/config/sudoApplication';
import { HTTP_TYPES } from '@src/helpers/ApiHelper';
import { STORAGE_TAG_TOKEN, getStorage } from '@src/helpers/StorageHelper';
import axios from 'axios';
import { store } from '@src/store';

const errorCheck = (error: any) => {
	const errorMessage = error?.response?.data?.message[0] || 'Unknown error occurred.';
	if (error.response.status === 401) {
		// Handle expired token error here
		getStorage().removeItem(STORAGE_TAG_TOKEN);
		PubSub.publish(EVENT_TOPIC_FORCE_LOGOUT);
	} else {
		throw new Error(errorMessage);
	}
};

export const request = async (
	method: HTTP_TYPES,
	url: string,
	data?: any,
	params?: any,
	extraHeaders?: any,
	noHeaders?: boolean
) => {
	const headers = noHeaders
		? {}
		: {
				'x-phone-number': '15550535229',
				Authorization: 'Bearer ' + getStorage().getItem(STORAGE_TAG_TOKEN),
				...extraHeaders,
		  };
	const businessId: string | null = store?.getState()?.organization?.value?.businessId;

	try {
		const response = await axios({
			method,
			url: `${window?.config?.API_BASE_URL_V2}${url}`,
			data,
			params,
			headers,
		});

		return response;
	} catch (error) {
		errorCheck(error);
		throw error;
	}
};
